import React, { useEffect, useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Parallax from 'parallax-js'

import isMobile from '../../utils/mobileDetecter';

import peekStyle from './peek.module.css';

import MovePhone from '../../icons/MovePhone';

function useIsGyroscopeEnabled() {
  const [isGyroscopeEnabled, setIsGyroscopeEnabled] = useState(false);

  useEffect(() => {
    function handleDeviceOrientation() { setIsGyroscopeEnabled(true); }
    window.addEventListener('deviceorientation', handleDeviceOrientation);
    return (() => {
      window.removeEventListener('deviceorientation', handleDeviceOrientation);
    });
  }, [setIsGyroscopeEnabled]);

  return isGyroscopeEnabled;
}

const Peek = (props) => {
  const isGyroscopeEnabled = useIsGyroscopeEnabled();

  const scene = useRef(null);
  const parallaxInstance = useRef(null);

  const handleScroll = useCallback(() => {
    if (isMobile.any() && isGyroscopeEnabled) return;

    const { elementPositionY, elementCenterY, elementRangeY } = parallaxInstance.current;
    parallaxInstance.current.inputY = (elementPositionY - elementCenterY) / elementRangeY;
  }, [parallaxInstance, isGyroscopeEnabled]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return (() => {
      window.removeEventListener('scroll', handleScroll);
    });
  }, [handleScroll]);

  useEffect(() => {
    parallaxInstance.current = new Parallax(scene.current);
    return (() => {
      parallaxInstance.current.destroy();
    });
  }, [scene]);

  return (
    <div className={peekStyle.peekContainer}>
      <div
        ref={scene}

        data-relative-input="true"

        data-limit-x={props.limitX}
        data-limit-y={props.limitY}
      >
        <div
          data-depth-x={props.depthX}
          data-depth-y={props.depthY}

          data-limit-x={props.limitXLayer}
          data-limit-y={props.limitYLayer}
        >
          <img
            className={peekStyle.hiddenImage}
            src={props.hiddenImage}
            alt="Фоновое изображение"
            style={{ transform: `scale(${props.scale})`}}
          />
        </div>

        <div
          data-depth-x={-props.depthXOver}
          data-depth-y={-props.depthYOver}

          data-limit-x={props.limitXOverLayer}
          data-limit-y={props.limitYOverLayer}

          className={peekStyle.overImageContainer}
        >
          <img
            className={peekStyle.overImage}
            alt="Верхнее изображение"
            src={props.overImage}
            style={{ transform: `scale(${props.scaleOver})`}}
          />
        </div>
      </div>

      {isMobile.any() && isGyroscopeEnabled && (
        <div className={peekStyle.hint}>
          <MovePhone /> Перемещайте устройство
        </div>
      )}
    </div>
  );
}

Peek.propTypes = {
  hiddenImage:  PropTypes.string,
  overImage: PropTypes.string,

  limitX: PropTypes.number,
  limitY: PropTypes.number,

  depthX: PropTypes.number,
  depthY: PropTypes.number,
  limitXLayer: PropTypes.string,
  limitYLayer: PropTypes.string,
  scale: PropTypes.number,

  depthXOver: PropTypes.number,
  depthYOver: PropTypes.number,
  limitXOverLayer: PropTypes.string,
  limitYOverLayer: PropTypes.string,
  scaleOver: PropTypes.number,
}

Peek.defaultProps = {
  hiddenImage:  '',
  overImage: '',

  limitX: undefined,
  limitY: undefined,

  depthX: 0.6,
  depthY: 0.6,
  limitXLayer: '',
  limitYLayer: '',
  scale: 1,

  depthXOver: 0.2,
  depthYOver: 0.2,
  limitXOverLayer: '',
  limitYOverLayer: '',
  scaleOver: 1,
}

export default Peek;
